export default
{
    versione : '1.3.6'
}